import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-deleteNotification',
  templateUrl: './deleteNotification.component.html',
  styleUrls: ['./deleteNotification.component.scss']
})
export class DeleteNotificationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
